import { render, staticRenderFns } from "./BrandsInpi.vue?vue&type=template&id=24a150a6&scoped=true&"
import script from "./BrandsInpi.vue?vue&type=script&lang=js&"
export * from "./BrandsInpi.vue?vue&type=script&lang=js&"
import style0 from "./BrandsInpi.vue?vue&type=style&index=0&id=24a150a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a150a6",
  null
  
)

export default component.exports